import { useEffect } from "react";

const DEFAULT_TITLE = "MATPASS · La plateforme belge du matériel professionnel d'occasion";
const DEFAULT_DESCRIPTION =
  "Achetez et vendez du matériel professionnel d'occasion partout en Belgique : espaces verts, BTP, agriculture et outillage.";

function siteOrigin() {
  const fromEnv = (process.env.REACT_APP_SITE_URL || "").trim().replace(/\/$/, "");
  if (fromEnv) return fromEnv;
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "https://matpass.be";
}

function upsertMeta(attr, key, content) {
  if (content == null || content === "") return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Updates document title, description, Open Graph tags and canonical URL.
 * Use on public pages (home, search, listing, shop, legal).
 */
export function SeoHead({
  title,
  description,
  path,
  image,
  noindex = false,
  type = "website",
}) {
  useEffect(() => {
    const origin = siteOrigin();
    const cleanPath = path
      ? (path.startsWith("/") ? path : `/${path}`)
      : (typeof window !== "undefined" ? window.location.pathname : "/");
    const canonical = `${origin}${cleanPath.split("?")[0]}`;
    const fullTitle = title
      ? (title.includes("MATPASS") ? title : `${title} · MATPASS`)
      : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESCRIPTION;

    document.title = fullTitle;
    upsertMeta("name", "description", desc);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:type", type);
    const htmlLang = (typeof document !== "undefined" ? document.documentElement.lang : "fr") || "fr";
    const ogLocale = htmlLang.startsWith("nl") ? "nl_BE" : htmlLang.startsWith("en") ? "en_GB" : "fr_BE";
    upsertMeta("property", "og:locale", ogLocale);
    if (image) upsertMeta("property", "og:image", image);
    upsertMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    upsertCanonical(canonical);
  }, [title, description, path, image, noindex, type]);

  return null;
}

export { siteOrigin, DEFAULT_TITLE, DEFAULT_DESCRIPTION };
